import { GraphRange } from "@/store/types";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

export interface MultiChartConfig {
  title?: string;
  description?: string;
  data: any[];
  library?: any;
  type?: string;
  min?: number;
  max?: number;
  suggestedMin?: number;
  suggestedMax?: number;
  minHeight?: string;
  maxHeight?: string;
  flexBasis?: string;
}

@Component({})
export default class MultiChartWithSharedRange extends Vue {
  @Prop({
    required: true,
    default: () => {
      return [];
    }
  })
  charts!: Array<any>;

  @Prop(Array)
  times!: GraphRange[];

  @Prop(Number)
  selectedTime!: number;

  pickedTime: number = 0;

  mounted() {
    this.pickedTime = this.selectedTime;
    this.resizeCharts();
  }

  // Avoid queueing multiple resizing callbacks
  resizing = false;

  chartHeights: number[] = [];

  @Watch("$vuetify.breakpoint", { deep: true })
  @Watch("times")
  @Watch("charts.length")
  resizeCharts() {
    if (this.resizing) {
      return;
    }
    this.resizing = true;
    Vue.nextTick(() => {
      this.resizing = false;
      const chartContainer = this.$refs.chartContainer as HTMLElement[];
      chartContainer.forEach((chart, i) => {
        const [
          title,
          description,
          chartWithRange
        ] = (chart.childNodes as unknown) as HTMLElement[];
        const height =
          chart.offsetHeight - title.offsetHeight - description.offsetHeight;
        chartWithRange.style.height = height + "px";
        Vue.set(this.chartHeights, i, height);
      });
    });
  }
}
